import Loader from './loader.lib';

export default {
	async install(app, options = {}) {
		const loader = new Loader({ app, ...options });

		await loader.load();
	},
};
